export default {
    resetStateMutation() {},
}
